// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { BalanceDetailComponent } from 'src/app/modules/balances/pages/balance-detail/balance-detail.page';
import { BalancesListClosedComponent } from 'src/app/modules/balances/pages/balances-list-closed/balances-list-closed.page';
import { BalancesListFirstComponent } from 'src/app/modules/balances/pages/balances-list-first/balances-list-first.page';
import { BalancesListFollowingComponent } from 'src/app/modules/balances/pages/balances-list-following/balances-list-following.page';
import { BalancesListComponent } from 'src/app/modules/balances/pages/balances-list/balances-list.page';
// import { AddBalanceComponent } from 'src/app/modules/balances/pages/add-balance/add-balance.page';

const routes: Routes = [
  {
    path: 'list',
    component: BalancesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadBalancesList']
    },
  },
  {
    path: 'list-first',
    component: BalancesListFirstComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadBalancesList']
    },
  },
  {
    path: 'list-following',
    component: BalancesListFollowingComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadBalancesList']
    },
  },
  {
    path: 'list-closed',
    component: BalancesListClosedComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadBalancesList']
    },
  },
  {
    path: 'detail/:balanceId',
    component: BalanceDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateBalances']
    },
  },
  // {
  //   path: 'add',
  //   component: AddBalanceComponent,
  //   canActivate: [RoleGuard],
  //   data: {
  //     permissions: ['canCreateBalances']
  //   },
  // },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class BalancesRoutingModule { }
